import React, { useCallback, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { History, LocationState } from 'history';
import { useSelector } from 'react-redux';
import { AxiosError } from 'axios';
import { Glyphicon } from 'react-bootstrap';

import Error from '../../../../components/stateMessage/Error';
import TemplateForm from '../TemplateForm';
import {
  fetchCityTemplateAction,
  selectAreCityItineraryTemplatesLoading,
  selectHaveCityItineraryTemplatesLoaded,
  selectItineraryTemplate,
  setCityTemplateAction,
  updateItineraryTemplateAction,
} from '../../../../reduces/itineraryTemplates';
import { RootState } from '../../../../reduces/reducer';
import { useAppDispatch } from '../../../../store';
import {
  getItineraryTemplates,
  updateItineraryTemplates,
} from '../../../../services/templates';
import { Itinerary } from '../../../../types/Itinerary';
import NotFound from '../../../NotFound';

type Props = { history: History<LocationState> };

const ItineraryTemplateEditPage = ({ history }: Props) => {
  const dispatch = useAppDispatch();
  const { citySlug, id } = useParams();
  const { goBack } = history;
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const hideMessage = () => {
    setTimeout(() => {
      setErrorMessage(undefined);
    }, 5000);
  };

  const isTemplateLoading = useSelector((state: RootState) =>
    selectAreCityItineraryTemplatesLoading(state, citySlug)
  );
  const hasTemplateLoaded = useSelector((state: RootState) =>
    selectHaveCityItineraryTemplatesLoaded(state, citySlug)
  );
  const itineraryTemplate = useSelector((state: RootState) =>
    selectItineraryTemplate(state, id)
  );

  const onSave = async (template: Itinerary) => {
    if (!itineraryTemplate) return;
    try {
      const updatedFields = Object.fromEntries(
        Object.entries(template).filter(([k, v]) => itineraryTemplate[k] !== v)
      );
      const updatedTemplate = await updateItineraryTemplates(
        citySlug,
        id,
        updatedFields
      );
      dispatch(updateItineraryTemplateAction(id, updatedTemplate));
      goBack();
    } catch (e) {
      const error = e as AxiosError;
      setErrorMessage(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
      hideMessage();
    }
  };

  const fetchCityTemplates = useCallback(async () => {
    if (!isTemplateLoading && !hasTemplateLoaded) {
      try {
        dispatch(fetchCityTemplateAction(citySlug));
        const template = await getItineraryTemplates(citySlug);
        dispatch(setCityTemplateAction(citySlug, template));
      } catch (error) {}
    }
  }, [citySlug, dispatch, hasTemplateLoaded, isTemplateLoading]);

  useEffect(() => {
    fetchCityTemplates();
  }, [fetchCityTemplates]);

  if (isTemplateLoading) {
    <Glyphicon
      glyph='refresh'
      style={{
        display: 'block',
        marginLeft: 'auto',
        width: '50px',
        height: '50px',
        marginRight: 'auto',
      }}
      className='spinning'
    />;
  }

  if (!itineraryTemplate) {
    return <NotFound />;
  }

  return (
    <>
      {!!errorMessage && <Error text={errorMessage} />}
      <TemplateForm
        itineraryTemplate={itineraryTemplate}
        onSave={onSave}
        history={history}
      />
    </>
  );
};

export default ItineraryTemplateEditPage;
